<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M 11.25,15.75h3v4.5l4.5-4.5h3c0.828,0,1.5-0.672,1.5-1.5v-12c0-0.828-0.672-1.5-1.5-1.5h-12 c-0.828,0-1.5,0.672-1.5,1.5 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 4.5,3.75c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S2.843,3.75,4.5,3.75z "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 8.25,17.25V15 c0-2.071-1.679-3.75-3.75-3.75S0.75,12.929,0.75,15v2.25h1.5l0.75,6h3l0.75-6H8.25z "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 13.5,7.125c0-1.036,0.839-1.875,1.875-1.875 s1.875,0.839,1.875,1.875S16.411,9,15.375,9 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 15.375,11.25L15.375,11.25 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 15.375,11.25c-0.207,0-0.375,0.168-0.375,0.375 S15.168,12,15.375,12s0.375-0.168,0.375-0.375S15.582,11.25,15.375,11.25"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
  
export default {
  name: "IconQuests",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {
  },
  computed: {
  }
}
</script>